import React from 'react'

import { PostTypeThumbnail } from '../PostTypeThumbnail'
import * as S from './PostCell.styled'
import type { Props } from './types'

export const PostCell = ({ type, title, thumbnailUrl, resources, subtitle, pinned }: Props) => {
  return (
    <S.Container data-testid={`PostCell.container-${title}`}>
      <PostTypeThumbnail
        type={type}
        thumbnailUrl={thumbnailUrl}
        resources={resources}
        pinned={pinned}
      />
      <S.Description>
        <S.Title>{title}</S.Title>
        <S.Subtitle>{subtitle}</S.Subtitle>
      </S.Description>
    </S.Container>
  )
}
